import { render, staticRenderFns } from "./imgCode.vue?vue&type=template&id=f1c71514&scoped=true&"
import script from "./imgCode.vue?vue&type=script&lang=js&"
export * from "./imgCode.vue?vue&type=script&lang=js&"
import style0 from "./imgCode.vue?vue&type=style&index=0&id=f1c71514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c71514",
  null
  
)

component.options.__file = "imgCode.vue"
export default component.exports